<template>
	<div>
		<div class="card scam">
			<header class="card-header">
				<h3 class="card-title">Import new keywords</h3>
			</header>

			<div class="card-body">
				<section class="flex">
					<div class="twelve">
						<textarea v-model="newKeywords"></textarea>
					</div>
				</section>
				<section class="flex">
					<div class="nine">
						<p>Usage: One keyword per line,format muse be: keyword,language slug, like: vpn,en OR zeitung,de. For deleting: one keyword per line</p>
					</div>
					<div class="three">
						<a @click="saveToDb" class="inline btn btn-md btn-success"><i class="fas fa-save"></i> Import</a>
						<a @click="delFromDb" class="inline btn btn-md btn-danger"><i class="fas fa-save"></i> Delete</a>
					</div>
				</section>
			</div>
		</div>
		<div class="card scam">
			<header class="card-header">
				<h3 class="card-title">Most Recent Keywords</h3>
			</header>

			<div class="card-body">
				<section>
					<div class="flex justify-end">
						<div class="mb-1">
							<a @click="getMostRecents(100,'google')" class="inline btn btn-md" :class="{'btn-success' : type === 'google','btn-default' : type !== 'google'}"><i class="fas fa-save"></i> Google</a>
							<a @click="getMostRecents(100,'manual')" class="inline btn btn-md" :class="{'btn-success' : type === 'manual','btn-default' : type !== 'manual'}"><i class="fas fa-save"></i> Manual</a>
							<a @click="getMostRecents(100,'all')" class="inline btn btn-md" :class="{'btn-success' : type === 'all','btn-default' : type !== 'all'}"><i class="fas fa-save"></i> All</a>
						</div>
					</div>
					<div>
						<table style="width:100%" v-if="mostRecents.length > 0">
							<tr>
								<th>Keyword</th>
								<th>Type</th>
								<th>Added</th>
							</tr>
							<tr v-for="item in mostRecents">
								<td>{{item.query}}</td>
								<td>{{item.type}}</td>
								<td>{{item.updated_at}}</td>
							</tr>
						</table>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		props: {
			data: {
				type: Object
			},
		},
		data() {
			return {
				newKeywords: '',
				mostRecents: [],
				type: 'all',
			}
		},
		mounted() {
			this.getMostRecents(200, 'all');
		},
		methods: {
			saveToDb: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/rmsh/save',
						{
							keywords: vm.newKeywords
						},
				).then(function (response) {
					vm.$toastr.success('Keywords saved successfully.');
					vm.getMostRecents(100, 'manual');
				});
			},
			getMostRecents: function (limit, type = null) {
				if (type === null) {
					type = this.type;
				}
				if (type !== null) {
					this.type = type;
				}
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/rmsh/mostrecent', {
							params: {
								limit: limit,
								type: type
							}
						}
				).then(function (response) {
					if (response.data.hasOwnProperty('result')) {
						vm.mostRecents = response.data.result;
						vm.newKeywords = '';
					} else {
						vm.axiosError('Keywords loading failed.');
					}
				}).catch(function (e) {
					vm.axiosError('Keywords loaading failed.', e);
				});
			},
			delFromDb: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/rmsh/delete',
						{
							keywords: vm.newKeywords
						},
				).then(function (response) {
					if (response.data.success === true) {
						vm.$toastr.success('Keywords deleted successfully.');
						vm.getMostRecents(100, 'manual');
					} else {
						vm.axiosError('Keywords delete failed.');
					}
				}).catch(function (e) {
					vm.$toastr.error('Keywords delete failed.', 'Error');
					vm.errors.record(e.response.data);
				});
			},
			axiosError: function (message, e = null) {
				this.$toastr.error(message, 'Error');
				if (e !== null) {
					this.errors.record(e.response.data);
				}
			}
		}
	}
</script>
